/**
 * Identifiers for every UX sound the app can play.
 * Each id maps to one or more audio files (variations) in soundManifest.ts.
 */
export enum SoundId {
    CardDrop = 'CardDrop',
    CardPickup = 'CardPickup',
    /** Dropping an element into a board (rather than onto the open board's canvas) */
    BoardDrop = 'BoardDrop',
    /** A dragged comment thread shrinking into its pin as it's about to attach to an element */
    Contract = 'Contract',
    DeleteSomething = 'DeleteSomething',
    /** Something didn't work / isn't allowed (e.g. clicking a toolbar tool that must be dragged) */
    Error = 'Error',
    LineConnect = 'LineConnect',
    /** Any checkbox — shared/Roma checkboxes, to-do items, labels, toggles that look like checkboxes */
    CheckboxTick = 'CheckboxTick',
    CheckboxUntick = 'CheckboxUntick',
    PopupOpen = 'PopupOpen',
    ReactionAdd = 'ReactionAdd',
    RemoteUserDeselect = 'RemoteUserDeselect',
    RemoteUserSelect = 'RemoteUserSelect',
    RollOver = 'RollOver',
    /** "Double" rollover — used by the colour swatch tool in the toolbar */
    DoubleRollOver = 'DoubleRollOver',
    /** A collaborator's comment arriving (the local user's own comments are silent) */
    CommentAdd = 'CommentAdd',
    SwitchToggleOff = 'SwitchToggleOff',
    SwitchToggleOn = 'SwitchToggleOn',
    TaskNewTaskAppear = 'TaskNewTaskAppear',
}

/** Master volume, 0..1 (fixed for now) */
export const DEFAULT_SOUND_VOLUME = 0.07;
export const MIN_SOUND_VOLUME = 0;
export const MAX_SOUND_VOLUME = 1;
